<template>
    <div id="residence-terms-manager">
        <v-card ref="residenceTermsManager">
            <v-card-title>
                Residence Terms Manager
                <v-spacer></v-spacer>
                <residence-terms-add v-if="getAccess()" @refreshData="refreshData" @setNotification="setNotification">
                </residence-terms-add>
            </v-card-title>
            <v-card-subtitle>
                Advanced Options
            </v-card-subtitle>
            <v-card-text>
                <v-form ref="residenceTermsOptions">
                    <v-select v-model="residenceTermsStatus" :items="residenceTermsStatusItems"
                        label="Residence Terms Status" prepend-icon="mdi-list-status" required>
                    </v-select>
                </v-form>
            </v-card-text>
            <v-card-actions class="pb-4">
                <v-spacer></v-spacer>
                <v-btn class="white--text" :color="successColor">Search</v-btn>
                <v-btn :color="warningColor">Reset</v-btn>
            </v-card-actions>
            <v-divider></v-divider>
            <v-card-text>
                <v-data-table :headers="headers" :items="data" sort-by="term">
                    <template v-slot:item.actions="{ item }">
                        <residence-terms-edit v-if="getAccess()" :item="item" @refreshData="refreshData"
                            @setNotification="setNotification"></residence-terms-edit>
                        <residence-terms-delete v-if="getAccess()" :item="item" @refreshData="refreshData"
                            @setNotification="setNotification"></residence-terms-delete>
                        <v-btn @click="openInfoResidenceTermDialog(item)" :color="primaryColor" icon>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                        mdi-information
                                    </v-icon>
                                </template>
                                <span>More Information</span>
                            </v-tooltip>
                        </v-btn>
                    </template>
                    <template v-slot:item.getDefault="{ item }">
                        <v-chip :color="getDefaultColor(item)" small>
                            {{ getDefaultLabel(item) }}
                        </v-chip>
                    </template>
                    <template v-slot:item.getActive="{ item }">
                        <v-chip :color="getActiveColor(item)" small>
                            {{ getActiveLabel(item) }}
                        </v-chip>
                    </template>
                </v-data-table>
                <residence-terms-info :currentResidenceTerm="currentResidenceTerm"
                    :infoResidenceTermDialog="infoResidenceTermDialog"
                    @closeInfoResidenceTermDialog="closeInfoResidenceTermDialog"></residence-terms-info>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import ResidenceTermsAdd from './AddResidenceTerms';
import ResidenceTermsDelete from './DeleteResidenceTerms';
import ResidenceTermsEdit from './EditResidenceTerms';
import ResidenceTermsInfo from './InfoResidenceTerms';

export default {
    name: 'residence-terms-manager',
    components: {
        ResidenceTermsAdd,
        ResidenceTermsDelete,
        ResidenceTermsEdit,
        ResidenceTermsInfo
    },
    props: {
        data: {
            required: true,
            type: Array
        },
        permission: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            currentResidenceTerm: '',
            headers: [{
                    text: 'Name',
                    align: 'start',
                    value: 'term',
                },
                {
                    text: 'Created By',
                    value: 'createdByUsername',
                },
                {
                    text: 'Move-In Date',
                    value: 'moveInDate',
                },
                {
                    text: 'Term Start',
                    value: 'startDate',
                },
                {
                    text: 'Term End',
                    value: 'endDate',
                },
                {
                    sortable: false,
                    text: 'Default',
                    value: 'getDefault',
                }, 
                {
                    sortable: false,
                    text: 'Active',
                    value: 'getActive',
                },
                {
                    sortable: false,
                    text: 'Actions',
                    value: 'actions'
                }
            ],
            infoResidenceTermDialog: false,
            residenceTermsStatus: 'active',
            residenceTermsStatusItems: [{
                    text: 'Active',
                    value: 'active'
                },
                {
                    text: 'Previously Offered',
                    value: 'previous'
                }
            ]
        }
    },
    methods: {
        closeInfoResidenceTermDialog() {
            this.infoResidenceTermDialog = false;
        },
        getAccess() {
            if (this.permission.enabled == "1" && this.permission.access == "write") {
                return true;
            }

            return false;
        },
        getActiveColor(item) {
            if (item.active && item.active == "1") {
                return '#1dc9b7';
            }

            return '#f64e60';
        },
        getActiveLabel(item) {
            if (item.active && item.active == "1") {
                return 'Yes';
            }

            return 'No';
        },
        getDefaultColor(item) {
            if (item.default && item.default == "1") {
                return '#1dc9b7';
            }

            return '#f64e60';
        },
        getDefaultLabel(item) {
            if (item.default && item.default == "1") {
                return 'Yes';
            }

            return 'No';
        },
        openInfoResidenceTermDialog(item) {
            this.currentResidenceTerm = item;
            this.infoResidenceTermDialog = true;
        },
        refreshData() {
            this.$emit('refreshData');
        },
        setNotification(color, icon, message, status) {
            this.$emit('setNotification', color, icon, message, status);
        }
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        primaryColor() {
            return '#5867dd';
        },
        successColor() {
            return '#1dc9b7';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>